import { Component, Input } from '@angular/core';

@Component({
  selector: 'rt-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.less'],
  host: {
    '[class.has-bottom-separator]': 'hasBottomSeparator',
  },
})
export class TabsComponent {
  @Input() public hasBottomSeparator: boolean = true;
}
